<template>
  <div>
    <container :active_path="'/project/city'" :plate="'云项目'">
      <div class="base-warp">
        <div class="head">
          <div class="title">城市设置</div>
          <div class="btn-box">
            <el-button type="primary" size="mini" @click="showcitydialog = true" v-if="superManager">添加城市</el-button>
            <el-button type="danger" size="mini" @click="deleteCity" v-if="superManager">删除城市</el-button>
          </div>
        </div>

        <div class="table-box">
          <el-tabs v-model="activetab" tab-position="left">
            <el-tab-pane v-for="(regions, index) in tableData" :key="index">
              <template slot="label">
                <div class="tabs-label">
                  <el-avatar class="avatar" icon="el-icon-user-solid" :size="30" shape="circle" :src="regions.logo" fit="fill"></el-avatar>
                  <span class="text">{{ regions.label }}</span>
                </div>
              </template>
              <el-row>
                <el-col class="tabs-col" :span="leftspan">
                  <div class="tabs-head">
                    <span class="text title">区域</span>
                    <div class="add-box" v-if="leftspan == 20">
                      <el-input class="custom-input" v-model="addregionname" placeholder="请输入区域名称" size="mini" clearable></el-input>
                      <el-button class="add-btn" type="primary" size="mini" @click="addregion(regions, index)">添加区域</el-button>
                      <el-button type="primary" size="mini" @click="updateregions(regions)">保存</el-button>
                    </div>
                  </div>

                  <div class="region-box">
                    <div
                      class="changespan left-change-span"
                      v-if="leftspan == 20"
                      @click="
                        leftspan = 4;
                        rightspan = 20;
                      "
                    >
                      <span class="text el-icon-d-arrow-left"></span>
                    </div>
                    <div class="region-cell-box" v-for="(region, rindex) in regions.children" :key="rindex">
                        <el-collapse v-model="regionactivename" accordion class="region-cell">
                            <el-collapse-item  :title="region.label">
                                <div class="room-number-warp">
                                <transition-group name="flip-list" tag="div">
                                    <div class="room-number-cell" draggable="true" @dragstart="regiondranstart(index, rindex, sindex, street)" @dragend="regiondragend" @dragenter="regiondragenter(sindex)" v-for="(street, sindex) in region.children" :key="sindex">
                                      <div class="cell-warp" v-if="editstreetindex == sindex + '-' + rindex || !street.label">
                                          <el-input v-model="street.label" class="custom-input room-number-input" placeholder="请输入片区名称" size="small" maxlength="10" clearable></el-input>
                                          <el-button type="text" @click="savecity(region,sindex)">保存</el-button>
                                          <el-button type="text" @click="cancelcity(region,sindex)">取消</el-button>
                                      </div>
                                      <div class="cell-warp" v-else>
                                          <span class="text">{{ street.label }}</span>
                                          <el-button type="text" icon="el-icon-edit" @click="editstreetindex = sindex + '-' + rindex"></el-button>
                                          <el-button type="text" class="del-btn" icon="el-icon-delete" @click="deletestreet(index,rindex,sindex)"></el-button>
                                      </div>
                                    </div>
                                </transition-group>

                                <div class="room-number-cell">
                                    <el-button class="add-room-number-btn" type="primary" size="small" icon="el-icon-plus" @click="addstreet(regions, region, index, rindex)">添加片区</el-button>
                                </div>
                                </div>
                            </el-collapse-item>
                        </el-collapse>
                        <div class="region-btn-box">
                            <el-button type="text" class="del-btn" icon="el-icon-delete" @click="deleteArea(index,rindex)"></el-button>
                        </div>
                    </div>
                  </div>
                </el-col>
                <el-col class="tabs-col" :span="rightspan">
                  <div class="tabs-head">
                    <span class="text title">地铁线路</span>
                    <div class="add-box" v-if="rightspan == 20">
                      <el-input class="custom-input" v-model="addmetroname" placeholder="请输入地铁线路名称" size="mini" clearable></el-input>
                      <el-button class="add-btn" type="primary" size="mini" @click="addmetro(regions, index)">添加地铁线路</el-button>
                      <el-button type="primary" size="mini" @click="updateregions(regions)">保存</el-button>
                    </div>
                  </div>
                  <div class="region-box" v-if="regions.metros">
                    <div
                      class="changespan right-change-span"
                      v-if="rightspan == 20"
                      @click="
                        leftspan = 20;
                        rightspan = 4;
                      "
                    >
                      <span class="text el-icon-d-arrow-right"></span>
                    </div>
                    <div class="region-cell-box metro-cell-box" v-for="(region, rindex) in regions.metros" :key="rindex">
                        <el-collapse v-model="regionactivename" accordion class="region-cell">
                            <el-collapse-item   :title="region.label">
                                <div class="room-number-warp">
                                <transition-group name="flip-list" tag="div">
                                    <div class="room-number-cell" draggable="true" @dragstart="metrodranstart(index, rindex, sindex, street)" @dragend="metrodragend" @dragenter="metrodragenter(sindex)" v-for="(street, sindex) in region.children" :key="sindex">
                                      <div class="cell-warp" v-if="editmetroindex == sindex + '-' + rindex || !street.label">
                                          <el-input v-model="street.label" class="custom-input room-number-input" placeholder="请输入地铁站" size="small" maxlength="10" clearable></el-input>
                                          <el-button type="text" @click="savemetro(region,sindex)">保存</el-button>
                                          <el-button type="text" @click="cancelmetro(region,sindex)">取消</el-button>
                                      </div>
                                      <div class="cell-warp" v-else>
                                          <span class="text">{{ street.label }}</span>
                                          <el-button type="text" icon="el-icon-edit" @click="editmetroindex = sindex + '-' + rindex"></el-button>
                                          <el-button type="text" color="#f00000" class="del-btn" icon="el-icon-delete" @click="deletemetrostation(index,rindex,sindex)"></el-button>
                                      </div>
                                    </div>
                                </transition-group>

                                <div class="room-number-cell">
                                    <el-button class="add-room-number-btn" type="primary" size="small" icon="el-icon-plus" @click="addstmetrostation(regions, region, index, rindex)">添加地铁站</el-button>
                                </div>
                                </div>
                            </el-collapse-item>
                        </el-collapse>
                        <div class="region-btn-box">
                            <el-button type="text" class="del-btn" icon="el-icon-delete" @click="deletemetroline(index,rindex)"></el-button>
                        </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </container>

    <el-dialog title="添加城市" :visible.sync="showcitydialog" width="600px">
      <el-form :model="cityform" ref="form" label-width="80px" :inline="false" size="mini">
        <el-form-item label="城市名称">
          <el-input v-model="cityform.label"></el-input>
        </el-form-item>
        <el-form-item label="logo">
          <el-upload class="upload-demo" action="/api/Upload/uploadFile/" :on-success="handleAvatarSuccess" drag>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过1M</div>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addcity">添加</el-button>
          <el-button @click="showcitydialog = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Container from "../../../components/container.vue";
export default {
  components: {
    Container
  },
  data() {
    return {
      showcitydialog: false,
      tableData: [],
      cityform: {
        label: "",
        imgs: ""
      },
      activetab: 0,
      addregionname: "",
      addmetroname: "",
      editstreetindex: "",
      editmetroindex: "",
      leftspan: 20,
      rightspan: 4,
      regionactivename: 0,
      metroactivename: 0,
      activeindex: "",
      activerindex: "",
      activesindex: "",
      activeitem: "",
      newactivesindex: "",
      managedCity: "",
      superManager: false
    };
  },
  mounted() {
    let managedCity = this.$store.getters.getuser.city;
    this.managedCity = managedCity;
    if (managedCity === "全部") {
      this.superManager = true;
    }
    this.getCityList();
  },
  methods: {
    addstmetrostation(regions, region, index, rindex) {
      var obj = {
        label: ""
      };
      region.children.push(obj);
      regions.metros[rindex] = region;
      this.tableData[index] = regions;
      var len = region.children.length - 1;
      this.editmetroindex = len + "-" + rindex;
      this.$forceUpdate();
    },
    addstreet(regions, region, index, rindex) {
      var obj = {
        label: ""
      };
      region.children.push(obj);
      regions.children[rindex] = region;
      this.tableData[index] = regions;
      var len = region.children.length - 1;
      this.editstreetindex = len + "-" + rindex;
      this.$forceUpdate();
    },
    deleteArea(index,rindex){
      this.$confirm('是否确认删除？删除后需保存生效。').then(
        confirm=>{
          this.tableData[index].children.splice(rindex,1);
          this.$forceUpdate();
          this.$message.success('删除成功！');
        },
        cancel=> {
          this.$message.info('已取消删除');
        }
      )
    },
    deletestreet(index,rindex,sindex) {
      this.$confirm('是否确认删除？删除后需保存生效。').then(
        confirm=>{
          this.tableData[index].children[rindex].children.splice(sindex,1);
          this.$forceUpdate();
          this.$message.success('删除成功！');
        },
        cancel=> {
          this.$message.info('已取消删除');
        }
      )
    },
    deletemetroline(index,rindex){
      this.$confirm('是否确认删除？删除后需保存生效。').then(
        confirm=>{
          this.tableData[index].metros.splice(rindex,1);
          this.$forceUpdate();
          this.$message.success('删除成功！');
        },
        cancel=> {
          this.$message.info('已取消删除');
        }
      )
    },
    deletemetrostation(index,rindex,sindex){
      this.$confirm('是否确认删除？删除后需保存生效。').then(
        confirm=>{
          this.tableData[index].metros[rindex].children.splice(sindex,1);
          this.$forceUpdate();
          this.$message.success('删除成功！');
        },
        cancel=> {
          this.$message.info('已取消删除');
        }
      )
    },
    savemetro(region,sindex) {
      if(region.children[sindex].label == ''){
        this.$message.warning("请输入地铁站");
      }else{
        this.editmetroindex = "";
      }
    },
    savecity(region,sindex) {
      if(region.children[sindex].label == ''){
        this.$message.warning("请输入片区");
      }else{
        this.editstreetindex = "";
      }
    },
    cancelmetro(region,sindex){
      if(region.children[sindex].label == '')  region.children.pop();
      this.editmetroindex = "";
    },
    cancelcity(region,sindex){
      if(region.children[sindex].label == '')  region.children.pop();
      this.editstreetindex = "";
    },
    // handlecityandmetro(method,type,region,sindex){
    //   if(region.children[sindex].label == ''){
    //     if(method === 'cancel'){
    //       region.children.pop();
    //     }else if(method === 'save'){
    //       this.$message.warning("不可保存为空");
    //     }
    //   }else{
    //     if(type === 'city'){
    //       this.editstreetindex = "";
    //     }else if(type === 'metro'){
    //       this.editmetroindex = "";
    //     }
    //   }
    // },
    addregion(item, index) {
      if (!this.addregionname) return;
      var obj = {
        label: this.addregionname,
        children: []
      };
      item.children.push(obj);
      this.tableData[index] = item;
      this.addregionname = "";
      this.$forceUpdate();
    },
    addmetro(item, index) {
      if (!this.addmetroname) return;
      var obj = {
        label: this.addmetroname,
        children: []
      };
      if (item.metros) {
        item.metros.push(obj);
      } else {
        item.metros = [obj];
      }
      this.tableData[index] = item;
      this.addmetroname = "";
      this.$forceUpdate();
    },
    getCityList() {
      this.$api.getCityList("").then((data) => {
        for (let city of data) {
          if (!city.metros) city.metros = [];
        }
        if (this.managedCity !== "全部") {
          data = data.filter((item) => {
            return item.label === this.managedCity;
          });
        }
        this.tableData = data;
      });
    },
    updateregions(regions) {
      var params = {
        id: regions._id["$oid"],
        children: JSON.stringify(regions.children),
        metros: JSON.stringify(regions.metros)
      };
      this.$api.updateProjectCity(params).then((data) => {
        this.$message.success(data);
      });
    },
    addcity() {
      var params = {
        label: this.cityform.label,
        logo: this.cityform.imgs
      };
      this.$api.addProjectCity(params).then((data) => {
        this.$message.success(data);
        this.showcitydialog = false;
        var obj = {
          label: "",
          imgs: ""
        };
        this.cityform = obj;
        this.getCityList();
      });
    },
    deleteCity() {
      let index = Number(this.activetab);
      let city = this.tableData[index].label;
      this.$confirm(`是否确定删除城市"${city}"`).then(
        confirm=>{
          let id = this.tableData[index]._id['$oid'];
          var params = {
            id
          }
          this.$api.deleteProjectCity(params).then(
            data=>{
              this.activetab = '0';
              this.$message.success(data);
              this.getCityList();
            }
          )
        },
        cancel=>{
          this.$message.info("已取消删除")
        }
      )

    },
    handleAvatarSuccess(e) {
      let { data, msg } = e;
      if (data) {
        this.$message.success(msg);
        this.cityform.imgs = data;
      } else {
        this.$message.error(msg);
      }
    },
    metrodranstart(index, rindex, sindex, item) {
      this.activeindex = index;
      this.activerindex = rindex;
      this.activesindex = sindex;
      this.activeitem = item;
    },
    metrodragend: function() {
      if (this.activesindex != this.newactivesindex) {
        let newItems1 = this.tableData[this.activeindex].metros;
        let newItems = newItems1[this.activerindex].children;
        // 删除老的节点
        newItems.splice(this.activesindex, 1);
        // 在列表中目标位置增加新的节点
        newItems.splice(this.newactivesindex, 0, this.activeitem);
        // this.items一改变，transition-group就起了作用
        newItems1[this.activerindex].children = newItems;
        this.tableData[this.activeindex].metros = newItems1;
      }
    },
    metrodragenter: function(sindex) {
      this.newactivesindex = sindex;
    },
    regiondranstart(index, rindex, sindex, item) {
      this.activeindex = index;
      this.activerindex = rindex;
      this.activesindex = sindex;
      this.activeitem = item;
    },
    regiondragend: function() {
      if (this.activesindex != this.newactivesindex) {
        let newItems1 = this.tableData[this.activeindex].children;
        let newItems = newItems1[this.activerindex].children;
        // 删除老的节点
        newItems.splice(this.activesindex, 1);
        // 在列表中目标位置增加新的节点
        newItems.splice(this.newactivesindex, 0, this.activeitem);
        // this.items一改变，transition-group就起了作用
        newItems1[this.activerindex].children = newItems;
        this.tableData[this.activeindex].children = newItems1;
      }
    },
    regiondragenter: function(sindex) {
      this.newactivesindex = sindex;
    }
  }
};
</script>

<style lang="scss" scoped>
.head {
  overflow: hidden;
  padding-bottom: 4px;
  .title {
    line-height: 28px;
    float: left;
  }
  .btn-box {
    float: right;
  }
}
.table-box {
  margin-top: 10px;
  ::v-deep .el-tabs__item {
    border-bottom: 1px solid #ebeef5;
    background: #ccc;
    color: #666;
  }
  ::v-deep .el-tabs__item.is-active {
    background: #e6a23c;
    color: #fff;
  }
  .tabs-label {
    box-sizing: border-box;
    .avatar {
      vertical-align: middle;
    }
    .text {
      margin-left: 2px;
      font-size: 14px;
      vertical-align: middle;
    }
  }
  .tabs-col {
    border-right: 1px solid #ccc;
    padding: 0 10px;
    position: relative;
    overflow: scroll;
    height: 90vh;
    .changespan {
      position: sticky;
      top: 300px;
      background: rgba($color: #999, $alpha: 0.6);
      width: 40px;
      height: 100px;
      .text {
        line-height: 100px;
        font-size: 40px;
        text-align: center;
        color: #fff;
        display: inline-block;
        width: 100%;
      }
    }
    .changespan.left-change-span {
      // right: 4px;
      float: right;
    }
    .changespan.right-change-span {
      float: left;
    }
  }
  .tabs-head {
    overflow: hidden;
    background: #f7f7f7;
    border-bottom: 1px dashed #ccc;
    padding: 4px 10px;
    box-sizing: border-box;
    position: sticky;
    top: 0;
    z-index: 10;
    .text.title {
      float: left;
      line-height: 28px;
    }
    .add-box {
      float: right;
      display: flex;
      .custom-input {
        margin-right: 10px;
      }
    }
  }

  .region-box {
    .region-cell-box.metro-cell-box{
        margin-left: 50px;
        margin-right: 0px;
    }
    .region-cell-box{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-right: 50px;
        .region-btn-box{
            flex: 1;
            padding: 0px 5px;
        }
        .del-btn{
            color: #f00000;
        }
        .region-cell {
            width: 100%;
            .text.region-name {
                font-size: 18px;
                padding: 4px 10px;
            }
            .room-number-warp {
                overflow: hidden;
                padding: 10px;
                .room-number-cell {
                    float: left;
                    width: 230px;
                    height: 40px;
                    box-shadow: 0 0 4px 1px #c0c4cc;
                    overflow: hidden;
                    margin-right: 10px;
                    margin-bottom: 20px;
                .cell-warp {
                    position: relative;
                    padding: 0 10px;
                    .text {
                        width: 150px;
                        display: inline-block;
                        box-sizing: border-box;
                    }
                    .custom-input.room-number-input {
                        width: 150px;
                        ::v-deep .el-input__inner {
                            border-radius: 0;
                        }
                    }
                    .el-button--text {
                        width: 25px;
                    }
                }
                    .add-room-number-btn {
                        width: 230px;
                        height: 40px;
                        border-radius: 0;
                    }
                }
            }
        }
    }
  }
}
</style>
